// 申请类型
export const applyTypes = [
    { value: 'ORDINARY', text: '普通轮候通道' },
    { value: 'PRIORITY', text: '优先轮候通道' },
];
